import {
    AlertUpdated,
} from '../actions/AlertActions'
import { alertService, initialAlertState } from '../../services/alert-service';


export const AlertReducer = (state = initialAlertState, action) => {
	switch (action.type) {
		case AlertUpdated:
			return alertService.getAlertState();
		default:
			return state;
	}
};
